export function urlJoin(...parts: string[]): string {
  return parts.map((x) => x.replace(/(^\/|\/$)/, '')).join('/');
}
